import React from 'react';
import { AsyncComponent } from '@twigeducation/async-component';
import { withSignoutRedirect } from '@twigeducation/oidc-client-react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import AsyncComponentError from '../AsyncComponentError';

const NavbarComponent = props => (
    <AsyncComponent appName="ms-navbar-mfe" componentName="Navbar" errorComponent={AsyncComponentError} {...props} />
);

const NavbarWithLogoutHandler = ({ onLogout, ...props }) => {
    const handleLogout = shouldLogout => {
        if (shouldLogout) {
            onLogout();
        } else {
            window.location.href = window.config.PRODUCT_SELECTION_URL;
        }
    };

    return <NavbarComponent {...props} onLogout={handleLogout} />;
};

NavbarWithLogoutHandler.propTypes = {
    onLogout: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({ userInfo: state.userInfo, hostApp: 'MS', featureFlags: state.featureFlags });
export default withSignoutRedirect(() => {})(connect(mapStateToProps)(NavbarWithLogoutHandler));
